<template>
  <AppBarLayout>
    <template #default="{ activeHierarchy }">
      <div
        ref="containerCyber"
        :class="`${
          isDataAssessment === API_STATUS.NO_DATA ||
          isDataAssessment === API_STATUS.NO_ACTION
            ? 'no__data'
            : 'main'
        } tw-overflow-x-hidden`"
      >
        <ActivePathWrapper
          v-if="isDataAssessment === API_STATUS.HAS_DATA"
          class="tw-bg-[#FFFFFF] !tw-shadow-none xl:tw-min-w-[1860px]"
          :active-hierarchy="activeHierarchy"
        />
        <BrandPattern4
          v-if="
            isDataAssessment === API_STATUS.NO_DATA ||
            isDataAssessment === API_STATUS.NO_ACTION
          "
          page="APPBARLAYOUT"
        />

        <div
          v-if="
            isDataAssessment === API_STATUS.NO_DATA ||
            isDataAssessment === API_STATUS.NO_ACTION
          "
        >
          <div class="tw-flex tw-justify-center tw-mt-[185px]">
            <NoDataCyberProfile
              :is-no-data="isDataAssessment === API_STATUS.NO_DATA"
              @update-path="isDataAssessment = API_STATUS.HAS_DATA"
            />
          </div>
        </div>
        <!-- header -->
        <div
          v-if="isDataAssessment === API_STATUS.HAS_DATA"
          class="header-container lg:tw-flex tw-justify-between tw-bg-white xl:tw-px-[60px] xl:tw-py-[48px] tw-px-[20px] tw-py-[20px] xl:tw-min-w-[1860px]"
        >
          <div
            class="md:tw-leading-[46px] md:tw-text-[22px] tw-text-[18px] tw-text-[#211F58] md:tw-mb-[0px] tw-mb-[10px] tw-flex"
          >
            <span class="tw-font-semibold"
              >{{
                getComponentUiText("app-share-cyber-profile-title-1")
              }}:</span
            >
            <span
              v-if="
                !loadingSplit[Checklist.getChecklistReportDataSummary] &&
                checklistSummaryReportData &&
                checklistSummaryReportData.checklistDate
              "
              data-cy="cyber-profile-checklist-name"
              class="tw-font-normal tw-ml-[10px]"
              >{{ checklistSummaryReportData?.checklistName }} -
              {{
                convertUTCTimeToLocalTime(
                  checklistSummaryReportData?.checklistDate,
                )
              }}
            </span>
            <p
              v-if="loadingSplit[Checklist.getChecklistReportDataSummary]"
              class="tw-ml-[10px] custom-global-skeleton tw-w-[250px] tw-h-full tw-rounded-[6px]"
            ></p>
          </div>
          <div class="tw-flex tw-gap-[20px]">
            <div
              v-if="isLoading || loadingInfo"
              :class="`toggle-switch-view tw-w-full tw-flex tw-rounded-[6px] tw-bg-[#ffffff] !tw-p-0 tw-items-center`"
            >
              <div class="tw-justify-end">
                <!-- eslint-disable vue/no-unused-refs -->
                <LottieAnimation
                  ref="anim"
                  :animation-data="ProgressAnimation"
                  :auto-play="true"
                  :loop="true"
                />
              </div>
            </div>
            <div
              v-else
              id="chr-print"
              class="toggle-switch-view tw-cursor-pointer"
              @mouseover="isPrintHover = true"
              @mouseout="isPrintHover = false"
              @click="printPdf"
            >
              <PrintIcon
                class="tw-cursor-pointer"
                style="width: 18px; height: 18px"
                :is-hover="isPrintHover"
              />
            </div>
            <!-- Option modal -->
            <div
              id="chr-display-settings"
              class="toggle-switch-view tw-relative tw-cursor-pointer"
              :class="
                isCheckToggleOptionSetting ? 'setting-option-selected' : ''
              "
              @click="openDisplayOption"
              @mouseover="isCogHover = true"
              @mouseout="isCogHover = false"
            >
              <label class="tw-cursor-pointer">
                <span>
                  <img
                    v-show="isCheckToggleOptionSetting"
                    src="@/assets/img/setting_option_selected.svg"
                    alt=""
                    class="tw-w-[18px] tw-h-[18px]"
                  />
                  <img
                    v-show="
                      !isCheckToggleOptionSetting &&
                      !isShowToolTip &&
                      !isCogHover
                    "
                    src="@/assets/img/setting_option.svg"
                    alt=""
                    class="tw-w-[18px] tw-h-[18px]"
                  />
                  <img
                    v-show="
                      !isCheckToggleOptionSetting &&
                      (isShowToolTip || isCogHover)
                    "
                    src="@/assets/img/setting_option_active.svg"
                    alt=""
                    class="tw-w-[18px] tw-h-[18px]"
                  />
                </span>
              </label>
            </div>

            <b-popover
              ref="popover_option"
              target="chr-display-settings"
              placement="bottom-end"
              click="true"
              :offset="OFFSET_POPOVER"
              :custom-class="`custom-actions-popover assessment-display-options`"
              class="tw-absolute"
              @show="isShowToolTip = true"
              @hidden="isShowToolTip = false"
            >
              <AssessmentDisplayOptions :list-option="listOption" />
            </b-popover>
            <!-- End Option modal -->
            <div
              id="chr-assessment-switcher"
              class="header__dot tw-items-center tw-flex tw-justify-center"
            >
              <AssessmentSwitcherDropdown
                :data="checkLists"
                :is-show-landing-page="loadingInfo ? false : true"
                :is-no-data="isDataAssessment === API_STATUS.NO_DATA"
                :is-loading="isLoading || loadingInfo"
                @on-select-checklist="onSelectChecklist"
              />
            </div>
          </div>
        </div>
        <!-- content -->
        <div
          v-if="isDataAssessment === API_STATUS.HAS_DATA"
          :class="`  xl:tw-p-[96px] tw-p-[20px] xl:tw-w-[1860px] chr-page`"
        >
          <div ref="componentRef" :class="`content_wraper `">
            <div id="print_content" class="pin_wraper">
              <div
                id="section1"
                :class="`2xl:tw-flex tw-gap-[60px] tw-bg-[#F2F8FF] xl:tw-py-[100px] xl:tw-px-[80px] tw-p-[20px] ${
                  currentOrgData?.logoImageFileId ? 'tw-items-center' : ''
                }`"
              >
                <div
                  v-if="currentOrgData"
                  :class="`tw-flex ${
                    currentOrgData?.logoImageFileId
                      ? 'tw-flex-col'
                      : 'tw-h-[70px]'
                  } ${
                    currentOrgData?.logoImageFileId
                      ? 'tw-gap-[10px]'
                      : 'tw-gap-[14px]'
                  } 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px]`"
                >
                  <OrgAvatar
                    v-if="
                      currentOrgData?.nameLegal ||
                      currentOrgData?.logoImageFileId
                    "
                    :name="currentOrgData?.nameLegal?.split(' ')[0]"
                    :img-id="
                      currentOrgData?.logoImageFileId
                        ? currentOrgData?.logoImageFileId
                        : ''
                    "
                    :class-name="
                      currentOrgData?.logoImageFileId ? '!tw-h-[134px]' : ''
                    "
                    :img-class-name="'!tw-h-full'"
                  />
                  <div
                    class="tw-flex tw-uppercase tw-tracking-wide tw-flex-col tw-justify-center tw-text-[#211F58] tw-font-semibold"
                    :class="
                      currentOrgData?.logoImageFileId ? '' : 'tw-h-[70px]'
                    "
                  >
                    <span class="tw-text-[25px] tw-leading-[23px] tw-w-[300px]">
                      {{ currentOrgData?.nameLegal }}
                    </span>
                  </div>
                </div>
                <div
                  v-else
                  class="tw-flex 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px] tw-h-[70px] tw-w-[70px] bg-skeleton"
                ></div>
                <div
                  id="right-header"
                  :class="`2xl:tw-w-1/2 ${
                    currentOrgData?.logoImageFileId ? 'tw-mb-[33px]' : ''
                  }`"
                >
                  <div
                    id="right-header-item"
                    class="md:tw-flex tw-w-full tw-justify-between md:tw-mb-[0px]"
                  >
                    <div
                      v-if="loadingCurrentOrgParent"
                      class="tw-flex 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px] tw-h-[70px] bg-skeleton"
                    ></div>
                    <div
                      v-else-if="currentParentOrgData?.orgId"
                      class="tw-flex-1"
                    >
                      <div
                        class="tw-text-[13px] tw-text-[#211F58] tw-font-semibold tw-mb-[12px]"
                      >
                        {{
                          getComponentUiText(
                            "app-share-cyber-profile-prepared-by-1",
                          )
                        }}:
                      </div>
                      <div id="margin-top" class="tw-flex tw-gap-[40px]">
                        <div class="tw-flex">
                          <GlobalAvatar
                            v-if="
                              currentParentOrgData?.nameLegal ||
                              currentParentOrgData.logoLgImageFileId
                            "
                            :name="currentParentOrgData?.nameLegal"
                            :src="
                              currentParentOrgData.logoLgImageFileId
                                ? currentParentOrgData?.imgLogo
                                : ''
                            "
                            :class-name="`parent-share-avatar ${
                              currentParentOrgData.logoLgImageFileId
                                ? '!tw-h-[38px]'
                                : ''
                            }`"
                            :img-class-name="'!tw-h-full'"
                            :font-size="'14px'"
                            :font-weight="'700'"
                            :is-rectangle="true"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-else></div>
                    <div class="tw-flex-shrink-0">
                      <div
                        id="margin-top"
                        class="tw-mb-[12px] tw-leading-[19px] tw-text-[13px] tw-text-[#211F58] tw-font-semibold md:tw-mt-[0px] tw-mt-[10px]"
                      >
                        {{
                          getComponentUiText(
                            "app-share-cyber-profile-powered-by-1",
                          )
                        }}:
                      </div>
                      <div><CyberSystem /></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Content Cyber Health Repor -->
              <div
                id="section2"
                class="2xl:tw-flex xl:tw-px-[80px] xl:tw-pb-[80px] tw-px-[20px] tw-pb-[20px] tw-bg-[#F2F8FF] tw-gap-[60px] cyber__health__report"
              >
                <div
                  class="2xl:tw-w-1/2 tw-min-h-[330px] tw-w-[100%] xl:tw-mb-[0px] tw-mb-[20px] tw-py-[20px]"
                >
                  <div
                    class="tw-font-semibold xl:tw-text-[44px] tw-text-[30px] tw-text-[#211F58] xl:tw-leading-[57px] tw-leading-[27px] tw-mb-[16px]"
                  >
                    {{ getComponentUiText("app-share-cyber-profile-title-1") }}
                  </div>
                  <div
                    v-if="
                      !loadingSplit[Checklist.getChecklistReportDataSummary] &&
                      checklistSummaryReportData &&
                      checklistSummaryReportData.checklistDate
                    "
                    class="tw-text-[18px] tw-text-[#211F58] tw-leading-[23px]"
                  >
                    <span class="tw-font-medium"
                      >{{ checklistSummaryReportData?.checklistName }}:
                    </span>
                    <span class="tw-font-normal">
                      {{
                        convertUTCTimeToLocalTime(
                          checklistSummaryReportData?.checklistDate,
                        )
                      }}
                    </span>
                  </div>
                  <div
                    v-if="loadingSplit[Checklist.getChecklistReportDataSummary]"
                    class="tw-flex tw-h-[40px] bg-skeleton"
                  ></div>
                  <div
                    id="chr-sheading-statusnotes"
                    class="tw-w-fit xl:tw-text-[24px] tw-text-[20px] tw-text-[#211F58] tw-font-semibold xl:tw-mt-[50px] tw-mt-[20px] tw-mb-[12px]"
                  >
                    {{
                      getComponentUiText(
                        "app-share-cyber-profile-current-health-status-1",
                      )
                    }}
                  </div>
                  <div
                    class="tw-min-h-[100px] tw-w-[100%] tw-text-[#231F20] tw-text-base tw-font-normal tw-opacity-70"
                  >
                    {{
                      getComponentUiText(
                        "app-share-cyber-profile-current-health-status-description-1",
                      )
                    }}
                  </div>
                </div>
                <div class="2xl:tw-w-1/2 tw-font-normal tw-w-[100%]">
                  <div
                    id="print-pdf-status-score"
                    class="xl:tw-flex tw-gap-[40px]"
                  >
                    <div
                      id="print-pdf-status-score-item"
                      class="xl:tw-w-1/2 tw-h-[332px] tw-bg-[#FFF] tw-w-[100%] xl:tw-mb-[0px] tw-mb-[20px] currentHealth"
                    >
                      <!-- status  -->
                      <CurrentHealthStatus
                        :color="
                          reportDataCheckList?.checklistMetrics
                            ?.checklistGradeColour
                        "
                        :status="
                          reportDataCheckList?.checklistMetrics
                            ?.checklistGradeStatus
                        "
                        :backcround-color="
                          addOpacitiHex(
                            reportDataCheckList?.checklistMetrics
                              ?.checklistGradeColour,
                            0.15,
                          )
                        "
                        :text="
                          reportDataCheckList?.checklistMetrics?.checklistGrade
                        "
                        :loading="
                          !!loadingSplit[
                            Checklist.getChecklistReportDataMetrics
                          ]
                        "
                      />
                    </div>
                    <div
                      id="print-pdf-status-score-item"
                      class="xl:tw-w-1/2 tw-w-[100%] tw-bg-[#FFF] tw-h-[332px] content_score"
                    >
                      <!-- score -->
                      <Score
                        :color="
                          reportDataCheckList?.checklistMetrics
                            ?.checklistGradeColour
                        "
                        :color-default="
                          addOpacitiHex(
                            reportDataCheckList?.checklistMetrics
                              ?.checklistGradeColour,
                            0.15,
                          )
                        "
                        :pcnt-score="
                          reportDataCheckList?.checklistMetrics
                            ?.checklistScorePcnt * 100 || 0
                        "
                        :current-score="
                          reportDataCheckList?.checklistMetrics
                            ?.checklistScorePcnt || 0
                        "
                        :loading="
                          !!loadingSplit[
                            Checklist.getChecklistReportDataMetrics
                          ]
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="xl:tw-px-[80px] tw-px-[20px] content__Progress">
                <div
                  v-if="displayOption.progress"
                  id="flex-progress"
                  class="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-gap-[60px] xl:tw-py-[80px] tw-py-[20px]"
                >
                  <div
                    id="chr-progress"
                    class="tw-h-full xl:tw-mb-[0px] tw-mb-[20px]"
                  >
                    <!-- Progress -->
                    <NotesShare
                      :id="'chr-sheading-progress'"
                      :title="
                        getComponentUiText(
                          'app-share-cyber-profile-progress-title-1',
                        )
                      "
                      :is-progress="true"
                      :is-loading="
                        loadingSplit[Checklist.getChecklistReportDataSummary]
                      "
                      :is-edit-progress="penEdit === SHARING_SECTION.PROGRESS"
                      :is-discard="isDiscard"
                      @update:edit-progress="
                        (value) =>
                          updatePenEdit(SHARING_SECTION.PROGRESS, value)
                      "
                    />
                  </div>

                  <!-- Security & Stability Score -->
                  <SecurityStabilityScore
                    id="chr-security-stability-graph"
                    class="tw-h-[368px]"
                    :data="chartData"
                    :is-print="isPrint"
                    :is-loading="
                      loadingSplit[Checklist.getChecklistReportDataSummary] ||
                      loadingSplit[Checklist.getChecklistReportDataForecasts] ||
                      loadingSplit[Checklist.getChecklistReportDataHistory]
                    "
                  />
                </div>
                <div
                  v-if="
                    displayOption.progress &&
                    displayOption.achievementsAndProgress
                  "
                  class="tw-bg-[#EFF0F1] tw-h-[1px]"
                ></div>
                <div
                  v-if="displayOption.achievementsAndProgress"
                  id="chr-achievements-progress"
                  class="xl:tw-py-[80px] tw-py-[20px]"
                >
                  <AchievementsAndProgress
                    :is-loading="
                      loadingSplit[Checklist.getChecklistReportDataHistory]
                    "
                    :is-edit="penEdit === SHARING_SECTION.ACHIEVEMENTPROGRESS"
                    :is-progress="true"
                    @update:edit="
                      (value) =>
                        updatePenEdit(
                          SHARING_SECTION.ACHIEVEMENTPROGRESS,
                          value,
                        )
                    "
                    @on-form-invalid="(value) => (isFormInvalid = value)"
                  ></AchievementsAndProgress>
                </div>
              </div>
              <div
                v-if="displayOption.quickWins"
                id="chr-quickwins"
                class="xl:tw-p-[80px] tw-p-[20px] quick__wins"
              >
                <QuickWins
                  :is-enable-edit="
                    checklistSummaryReportData?.checklistStatusId !==
                    checklistStatusId.completed
                  "
                  :is-edit="penEdit === SHARING_SECTION.QUICK_WINS"
                  :root-checklist-report-id="rootChecklistReportId"
                  @update:edit="
                    (value) => updatePenEdit(SHARING_SECTION.QUICK_WINS, value)
                  "
                  @on-form-invalid="(value) => (isFormInvalid = value)"
                ></QuickWins>
              </div>
              <div
                v-if="displayOption.roadMap"
                id="chr-roadmap"
                class="xl:tw-p-[80px] tw-p-[20px] road__map !tw-bg-[#ffffff]"
              >
                <Roadmap
                  :is-enable-edit="
                    checklistSummaryReportData?.checklistStatusId !==
                    checklistStatusId.completed
                  "
                  :is-edit="penEdit === SHARING_SECTION.ROAD_MAP"
                  :root-checklist-report-id="rootChecklistReportId"
                  @update:edit="
                    (value) => updatePenEdit(SHARING_SECTION.ROAD_MAP, value)
                  "
                ></Roadmap>
              </div>
              <div
                v-if="displayOption.assessmentStats"
                id="chr-stats"
                class="xl:tw-p-[80px] tw-p-[20px] assessment__stat"
              >
                <AssessmentStatus
                  :is-loading="
                    isLoading ||
                    loadingSplit[
                      Checklist.getChecklistReportDataInfographics
                    ] ||
                    loadingSplit[Checklist.getChecklistReportDataSummary]
                  "
                />
              </div>
              <div
                v-if="
                  displayOption.trafficLights ||
                  displayOption.incidentsAndEvents ||
                  displayOption.notes
                "
                class="xl:tw-px-[80px] tw-px-[20px] xl:tw-mb-[80px] tw-mb-[20px] traffic__lights"
              >
                <div
                  v-if="displayOption.trafficLights"
                  class="xl:tw-pt-[80px] tw-pt-[20px]"
                >
                  <!-- Traffic Lights -->
                  <TrafficLightsProfile
                    :is-loading="
                      loadingSplit[Checklist.getChecklistReportDataCategories]
                    "
                    :is-enable-edit="
                      checklistSummaryReportData?.checklistStatusId !==
                      checklistStatusId.completed
                    "
                    :is-edit="penEdit === SHARING_SECTION.TRAFFIC_LIGHTS"
                    :is-call-api="isCallApiTrafficLights"
                    :traffic-lights-editing="trafficLightsEditing"
                    @update:edit="
                      (value) =>
                        updatePenEdit(SHARING_SECTION.TRAFFIC_LIGHTS, value)
                    "
                    @on-focus-out="onFocusOutTrafficLights"
                  />
                </div>
                <div
                  v-if="displayOption.incidentsAndEvents"
                  class="xl:tw-mt-[80px] tw-mt-[20px]"
                >
                  <IncidentsAndEvents
                    ref="incidentsAndEventsRef"
                    :is-loading="
                      loadingSplit[Checklist.getChecklistReportDataIncidents]
                    "
                    :is-edit="penEdit === SHARING_SECTION.INCIDENTS"
                    :is-discard="isDiscard"
                    @update:edit="
                      (value) => updatePenEdit(SHARING_SECTION.INCIDENTS, value)
                    "
                  ></IncidentsAndEvents>
                </div>
                <div
                  v-if="displayOption.notes"
                  id="chr-notes"
                  class="xl:tw-mt-[80px] tw-mt-[20px]"
                >
                  <!-- Notes -->
                  <NotesShare
                    :id="'chr-sheading-notes'"
                    :title="
                      getComponentUiText(
                        'app-share-cyber-profile-notes-title-1',
                      )
                    "
                    :is-loading="
                      loadingSplit[Checklist.getChecklistReportDataSummary]
                    "
                    :is-edit="penEdit === SHARING_SECTION.NOTES"
                    :is-discard="isDiscard"
                    @update:edit="
                      (value) => updatePenEdit(SHARING_SECTION.NOTES, value)
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import AssessmentSwitcherDropdown from "@/components/recommend/assessmentSwitcherDropdown/assessmentSwitcherDropdown.vue";
import { getComponentUiText, getImageData } from "@/utils/utilities";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import AssessmentDisplayOptions from "@/components/assessment/assessmentDisplayOptions.vue";
import CyberSystem from "@/components/svgs/cyberSystem.vue";
import TrafficLightsProfile from "@/components/share/trafficLightsProfile.vue";
import AchievementsAndProgress from "@/components/share/achievementsAndProgress.vue";
import NotesShare from "@/components/share/notesShare.vue";
import CurrentHealthStatus from "@/components/share/currentHealthStatus.vue";
import Score from "@/components/share/score.vue";
import SecurityStabilityScore from "@/components/share/securityStabilityScore.vue";
import AssessmentStatus from "@/components/share/assessmentStatus.vue";
import IncidentsAndEvents from "@/components/share/incidentsAndEvents.vue";
import Roadmap from "@/components/share/roadmap.vue";
import QuickWins from "@/components/share/quickWins.vue";
import { computed, onBeforeUnmount, onMounted, Ref, ref, watch } from "vue";
import NoDataCyberProfile from "./noDataCyberProfile.vue";
import store from "@/store";
import OrgAvatar from "@/components/share/orgAvatar.vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import { checklistStatusId } from "@/utils/constants";
import {
  API_STATUS,
  localStorageKey,
  MODAL_NAME,
  SHARING_SECTION,
} from "@/utils/constants";
import { ICyberReportDisplayOption } from "@/interfaces/shares";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import PrintIcon from "../../components/svgs/printIcon.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import router from "@/router";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { useVueToPrint } from "vue-to-print";
import { getOrgIdProfile, getParentOrg, getProfileImage } from "@/services/org";
import { getDataChart } from "@/services/sharing";
import { showError } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import { handleChecklistDataReportSplit } from "../../services/sharing";
import dayjs from "dayjs";

const initDisplayOption: ICyberReportDisplayOption = {
  progress: true,
  achievementsAndProgress: true,
  quickWins: true,
  roadMap: true,
  assessmentStats: true,
  trafficLights: true,
  incidentsAndEvents: true,
  notes: true,
};
const OFFSET_POPOVER = 20;

const isLoading = ref(true);
const loadingInfo = ref(false);
const currentChain = ref(0);
const penEdit = ref("");
const incidentsAndEventsRef: any = ref(null);
const isDiscard = ref(false);
const isDataAssessment: any = ref(API_STATUS.FETCHING);
const loadingCurrentOrg = ref(true);
const loadingCurrentOrgParent = ref(true);
const trafficLightsEditing: any = ref(null);
const isLastItemTrafficLights = ref(false);
const isCallApiTrafficLights = ref(false);
const rootChecklistReportId = ref(0);

const roadMapErrorData = computed(() => {
  return store.state.Sharing.roadMapErrorData;
});
const loadingSplit = computed(() => {
  return store.state.Sharing.loadingSplit;
});
const containerCyber = ref(null);

watch(
  () => penEdit.value,
  (value) => {
    if (value) {
      store.commit("Sharing/SET_IS_EDITS", true);
    } else {
      store.commit("Sharing/SET_IS_EDITS", false);
    }
  },
);

const isEdit = computed(() => store.state.Sharing.isEdit);

const showAreYouSureModal = (newPath?, { text }) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-modal-confirm-title-1",
      ),
      description: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-modal-confirm-description-1",
        false,
        { text: text },
      ),
      buttonText: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-modal-confirm-btn-yes-1",
      ),
      hiddenHelp: false,
      buttonRed: false,
      blueText: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-modal-confirm-btn-keep-editing-1",
      ),
    },
    events: {
      "update:data": async () => {
        await store.commit("Sharing/SET_IS_EDITS", false);
        if (newPath) {
          router.push(newPath);
        } else {
          await store.dispatch("Sharing/fetchChecklistReportData");
          await store.dispatch("Sharing/fetchServicesData");
          isDiscard.value = true;
          penEdit.value = "";
          setTimeout(() => {
            printPdf();
          }, 1000);
        }
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};
const isFormInvalid = ref(false);
const updatePenEdit = (type, value) => {
  if (isFormInvalid.value || roadMapErrorData.value.length) {
    return;
  }
  trafficLightsEditing.value = null;
  penEdit.value = value ? type : "";
};

const checklistSummaryReportData = computed(
  () => store.getters["Sharing/getChecklistSummary"],
);
const currentOrgId = computed(() => store.state.Org.currentOrg?.id);

const currentParentOrgData = ref();
const currentOrgData = ref();
const reportDataCheckList = computed(() => {
  return store.getters["Sharing/getChecklistReportData"];
});

const checkLists = computed<IAssessmentDetail[]>(() => {
  return store.getters["Sharing/getChecklists"] || [];
});

const docTitle = computed(() => {
  const dateCreated = checklistSummaryReportData?.value?.checklistDate
    ? dayjs(checklistSummaryReportData.value?.checklistDate).format("YYYYMMDD")
    : "";
  return `${currentOrgData.value?.nameShort?.toUpperCase()} Cyber Health Report ${checklistSummaryReportData
    .value?.checklistName}${dateCreated ? ` ${dateCreated}` : ""}`;
});

const componentRef = ref();
const { handlePrint } = useVueToPrint({
  content: componentRef,
  documentTitle: docTitle,
  removeAfterPrint: true,
  onAfterPrint: () => {
    setTimeout(() => {
      isPrint.value = false;
    }, 1000);
  },
});

const printPdf = async () => {
  if (isEdit.value) {
    await showAreYouSureModal("", {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-modal-confirm-description-print-1",
      ),
    });
    return;
  }
  isPrint.value = true;
  setTimeout(() => {
    handlePrint();
  }, 1000);
};

const isPrint = ref(false);

const handlePrintShortcut = (event) => {
  if ((event.ctrlKey || event.metaKey) && event.key === "p") {
    event.preventDefault();
    printPdf();
  }
};
const chartData = computed(() => {
  const data = store.getters["Sharing/getChecklistReportData"];
  return getDataChart(data);
});

onMounted(async () => {
  await store.dispatch("Sharing/resetSharingStore");
  await getOrgProfile();
  getDisplayOption();
  await getData();
  window.addEventListener("keydown", handlePrintShortcut);
  // window.addEventListener("click", handleClickOutside);
  eventEmitter.on(EmitterEvents.SHARING_CONFIRM_UPSERT_INCIDENT, (newPath) => {
    showAreYouSureModal(newPath, {
      text: getComponentUiText(
        "app-share-cyber-profile-incidents-and-events-modal-confirm-description-leave-1",
      ),
    });
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
  window.removeEventListener("keydown", handlePrintShortcut);
  eventEmitter.off(EmitterEvents.SHARING_CONFIRM_UPSERT_INCIDENT);
});

const onFocusOutTrafficLights = async (value) => {
  trafficLightsEditing.value = value;
  try {
    isCallApiTrafficLights.value = true;
    trafficLightsEditing.value = value.item;
    await store.dispatch("Sharing/updateChecklistTrafficLight", [
      trafficLightsEditing.value,
    ]);
    if (value.idx === -1) {
      isLastItemTrafficLights.value = true;
      penEdit.value = "";
    } else {
      isLastItemTrafficLights.value = false;
    }
  } catch (error) {
    console.log(error);
  } finally {
    setTimeout(() => {
      isCallApiTrafficLights.value = false;
    }, 1000);
  }
};

const handleClickOutside = (event: any) => {
  const nodeInput = document.getElementById("note_input");
  const progressInput = document.getElementById("progress_input");
  const penIconProgress = document.getElementById("pen-icon-progress");
  const penIconNote = document.getElementById("pen-icon-note");
  const penIconTrafficLights = document.getElementById("pen-icon-traffic");
  const targetId = event.target.id;
  const trafficSestion = document.getElementById("chr-trafficlights");
  if (
    penEdit.value === SHARING_SECTION.TRAFFIC_LIGHTS &&
    penIconTrafficLights &&
    !penIconTrafficLights.contains(event.target as Node) &&
    trafficLightsEditing.value
  ) {
    if (
      (trafficSestion && trafficSestion.contains(event.target as Node)) ||
      targetId.includes("chr-trafficlights-notes")
    ) {
      store.dispatch("Sharing/updateChecklistTrafficLight", [
        trafficLightsEditing.value,
      ]);
    } else {
      penEdit.value = "";
      isLastItemTrafficLights.value = false;
    }
    trafficLightsEditing.value = null;
    return;
  }
  if (
    nodeInput &&
    !nodeInput.contains(event.target as Node) &&
    penEdit.value === SHARING_SECTION.NOTES &&
    penIconNote &&
    !penIconNote.contains(event.target as Node)
  ) {
    penEdit.value = "";
    return;
  }
  if (
    progressInput &&
    !progressInput.contains(event.target as Node) &&
    penEdit.value === SHARING_SECTION.PROGRESS &&
    penIconProgress &&
    !penIconProgress.contains(event.target as Node)
  ) {
    penEdit.value = "";
    return;
  }
};

const getData = async () => {
  const body = document.getElementById("bodyPage");
  if (body) {
    body.style.overflow = "hidden";
  }

  isLoading.value = true;
  const fetchChecklistData = await store.dispatch(
    "Sharing/fetchChecklistsData",
  );
  isLoading.value = false;
  if (!fetchChecklistData || fetchChecklistData.length === 0) {
    isLoading.value = false;
    isDataAssessment.value = API_STATUS.NO_DATA;
    store.dispatch("Overlay/hideOverlay");
    return;
  } else {
    isDataAssessment.value = API_STATUS.HAS_DATA;
  }
  store.dispatch("Sharing/fetchChecklistReportData");
  await store.dispatch("Sharing/fetchServicesData");
  await Promise.all([
    store.dispatch("Sharing/fetchChecklistIncidentType"),
    store.dispatch("Sharing/fetchChecklistImpactLevel"),
    store.dispatch("Sharing/fetchChecklistCost"),
  ]);
};

//#region display option
const popover_option: any = ref(null);
const isCogHover: Ref<boolean> = ref(false);
const isPrintHover: Ref<boolean> = ref(false);
const isShowToolTip: Ref<boolean> = ref(false);
const displayOption: Ref<ICyberReportDisplayOption> = ref(initDisplayOption);
const isCheckToggleOptionSetting = computed(() => {
  return (
    !displayOption.value.progress ||
    !displayOption.value.achievementsAndProgress ||
    !displayOption.value.quickWins ||
    !displayOption.value.roadMap ||
    !displayOption.value.assessmentStats ||
    !displayOption.value.trafficLights ||
    !displayOption.value.incidentsAndEvents ||
    !displayOption.value.notes
  );
});

const currentChecklistReportId = computed(
  () => store.getters["Sharing/getChecklistReportId"],
);

const listOption = computed(() => [
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-progress-1",
    ),
    action: (value: boolean) => {
      displayOption.value.progress = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.checklistForecasts) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataForecasts,
            currentChecklistReportId.value,
          );
        }

        if (!reportDataCheckList.value.checklistHistory) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataHistory,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.progress,
    dataCy: "show-progress-cyber-profile",
  },
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-achievements-1",
    ),
    action: (value: boolean) => {
      displayOption.value.achievementsAndProgress = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.checklistHistory) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataHistory,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.achievementsAndProgress,
    dataCy: "show-achievements-cyber-profile",
  },
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-quick-wins-1",
    ),
    action: (value: boolean) => {
      displayOption.value.quickWins = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.checklistGroups) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataActions,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.quickWins,
    dataCy: "show-quickWins-cyber-profile",
  },
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-road-map-1",
    ),
    action: (value: boolean) => {
      displayOption.value.roadMap = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.checklistGroups) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataActions,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.roadMap,
    dataCy: "show-road-map-cyber-profile",
  },
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-assessment-stats-1",
    ),
    action: (value: boolean) => {
      displayOption.value.assessmentStats = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.checklistInfographics) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataInfographics,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.assessmentStats,
    dataCy: "show-stats-cyber-profile",
  },
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-traffic-lights-1",
    ),
    action: (value: boolean) => {
      displayOption.value.trafficLights = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.checklistCategories) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataCategories,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.trafficLights,
    dataCy: "show-traffic-lights-cyber-profile",
  },
  {
    title: getComponentUiText(
      "app-share-cyber-profile-display-option-incidents-events-1",
    ),
    action: (value: boolean) => {
      displayOption.value.incidentsAndEvents = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
      if (value) {
        if (!reportDataCheckList.value.incidents) {
          handleChecklistDataReportSplit(
            Checklist.getChecklistReportDataIncidents,
            currentChecklistReportId.value,
          );
        }
      }
    },
    value: displayOption.value.incidentsAndEvents,
    dataCy: "show-incidents-events-cyber-profile",
  },
  {
    title: getComponentUiText("app-share-cyber-profile-display-option-notes-1"),
    action: (value: boolean) => {
      displayOption.value.notes = value;
      localStorage.setItem(
        localStorageKey.cyberReportDisplayOption,
        JSON.stringify(displayOption.value),
      );
    },
    value: displayOption.value.notes,
    dataCy: "show-notes-cyber-profile",
  },
]);
const getDisplayOption = () => {
  let displayOptionStorage = localStorage.getItem(
    localStorageKey.cyberReportDisplayOption,
  );
  if (!displayOptionStorage) {
    localStorage.setItem(
      localStorageKey.cyberReportDisplayOption,
      JSON.stringify(initDisplayOption),
    );
  } else {
    displayOption.value = JSON.parse(displayOptionStorage);
  }
};

const openDisplayOption = () => {
  setTimeout(() => {
    popover_option?.value?.$emit("show");
  }, 500);
};
//#endregion

const addOpacitiHex = (hex, opacity) => {
  if (!hex) return;
  hex = hex.replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const alpha = Math.round(opacity * 255)
    .toString(16)
    .padStart(2, "0");
  return `#${hex}${alpha}`;
};
watch(
  () => currentOrgId.value,
  async (value, oldValue) => {
    localStorage.removeItem(localStorageKey.rootChecklistReportId);
    localStorage.removeItem(localStorageKey.checklistReportId);
    if (oldValue !== value) {
      containerCyber.value?.scrollTo({ top: 0, behavior: "smooth" });
      await getOrgProfile();
    }
    if (!oldValue) return;
    await getData();
  },
);

const currentOrg = computed(() => store.state.Org.currentOrg);

const getOrgProfile = async () => {
  loadingCurrentOrg.value = true;
  loadingCurrentOrgParent.value = true;
  // get current org profile
  if (!currentOrgId.value) return;
  try {
    const orgProfilePromise = [getOrgIdProfile(currentOrgId.value)];
    const res = await Promise.all(orgProfilePromise);
    if (res[0].status == 200) {
      const data = {
        ...currentOrg.value,
        ...res[0].data.data,
      };
      const logoImageFileId =
        data?.logosm?.logoSmImageFileId || data?.logolg?.logoLgImageFileId;
      currentOrgData.value = {
        ...data,
        logoImageFileId,
        profileData: {
          avatarImageId: data?.avatar?.avatarImageFileId,
        },
      };
      loadingCurrentOrg.value = false;
      if (data?.idParentOrg) {
        const orgParentProfilePromise = [
          getOrgIdProfile(data.idParentOrg),
          getParentOrg(data.idParentOrg),
        ];
        const resParent = await Promise.all(orgParentProfilePromise);
        if (resParent[0].status == 200 && resParent[1].status == 200) {
          const parentData = {
            ...resParent[0].data.data,
            ...resParent[1].data.data,
          };
          const logoImageFileIdParent =
            parentData?.logosm?.logoSmImageFileId ||
            parentData?.logolg?.logoLgImageFileId;
          const imgLogo = await getAvatarImg(
            logoImageFileIdParent,
            data?.idParentOrg,
          );
          currentParentOrgData.value = {
            ...parentData,
            logoLgImageFileId: logoImageFileIdParent,
            imgLogo,
          };
          loadingCurrentOrgParent.value = false;
        }
      } else {
        currentParentOrgData.value = null;
        loadingCurrentOrgParent.value = false;
      }
    }
  } catch (error: any) {
    loadingCurrentOrg.value = false;
    loadingCurrentOrgParent.value = false;
    showError(error.message);
  }
};

const getAvatarImg = async (imgId, orgId?) => {
  try {
    if (!imgId) return null;
    const res = await getProfileImage(imgId, orgId);
    const imageDetails = res.data.data;
    const file = await getImageData(imageDetails);
    return URL.createObjectURL(file);
  } catch (error) {
    console.error("Error in fetching image", error);
  }
};

const onSelectChecklist = async (item: IAssessmentDetail, index: number) => {
  if (currentChecklistReportId.value === item.checklistId) return;
  currentChain.value = index;

  const body = document.getElementById("bodyPage");
  if (body) body.style.overflow = "";

  try {
    localStorage.setItem(
      localStorageKey.rootChecklistReportId,
      `${checkLists.value[index].checklistId}`,
    );

    loadingInfo.value = true;
    rootChecklistReportId.value = checkLists.value[index].checklistId;
    await store.dispatch("Sharing/setChecklistReportId", item.checklistId);
    await store.dispatch("Recommend/setChecklistReportId", item.checklistId);
    await store.dispatch("Sharing/fetchChecklistReportData");
  } catch (error) {
    loadingInfo.value = false;
  } finally {
    loadingInfo.value = false;
  }
};
</script>

<style lang="scss" scoped>
#appBarLayout {
  overflow-y: hidden;
  background: #ffffff;
}

.no__data {
  background: var(--UI-light-sky-soft, #e4f1ff);
  // position: relative;
  height: 100%;
  // overflow-y: auto;
}

#body {
  flex-wrap: nowrap;
}

.main {
  background: rgba(239, 240, 241, 0.5);
  position: relative;
  height: 100%;
  overflow-y: auto;
}
.header {
  line-height: 46px;
}
.header__dot {
  width: 407px;
  height: 44px;
  border-radius: 6px;
  // border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #fff);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #fff);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  padding: 10px 14px;
}
.content_wraper {
  border-radius: 6px;
  background: var(--UI-white, #fff);
  box-shadow: 0px 0px 30px 0px rgba(57, 57, 57, 0.15);
  .pin_wraper {
    padding: 4px;
  }
}
.quick__wins,
.road__map,
.assessment__stat {
  border-top: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-row-bg, #fcfcfd);
}

.traffic__lights {
  border-top: 1px solid var(--UI-rule, #eff0f1);
}
.cyber__health__report {
  border-bottom: 1px solid var(--UI-rule, #eff0f1);
}
.currentHealth,
.content_score {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #fff);
}
.bg-skeleton {
  background: #eee;
  background: linear-gradient(90deg, #f2f8ff 10%, #e9e9e9 25%, #f2f8ff 35%);
  background-size: 200% 100%;
  animation: 1.5s custom-skeleton-loading linear infinite;
}
.toggle-switch-view {
  width: 46px;
  height: 44px;
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #fff);
  -webkit-box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  padding: 8px 14px;

  label {
    margin-bottom: 0;
  }
  .label {
    display: flex;
    cursor: pointer;
    padding: 10px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    color: var(--ui-light-grey, #b7b7b7);
    letter-spacing: 1px;
    border-radius: 6px;
    min-width: 16px;
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    &:checked + .label {
      background: var(--brand-navy, #211f58);
      color: #fff;
    }
  }
  &.setting-option-selected {
    background: var(--brand-navy, #211f58);
  }
}
.custom-actions-popover .popover-arrow {
  width: 14px;
  height: 14px;
  top: -8px;
}

.custom-actions-popover.bs-popover-bottom {
  margin-top: unset;

  .popover-arrow {
    top: -8px;
  }
}

.custom-actions-popover.bs-popover-top {
  .popover-arrow {
    bottom: -8px;
  }
}

.popover {
  border: none;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.popover-body {
  padding: 0 !important;
  min-width: 160px;
}
:deep(.popover-body) {
  max-height: 500px;
  overflow: auto;
}
.tw-font-Poppins {
  font-family: Poppins, sans-serif;
}

@media (max-width: 1919px) {
  .main {
    overflow-x: auto;
  }
}

@media print {
  @page {
    margin: 30px;
  }

  #body {
    -webkit-print-color-adjust: exact;
    background: red;
  }

  * {
    box-sizing: border-box;
  }

  #section1,
  #section2,
  #section3,
  #section4,
  #section5,
  #chr-stats {
    print-color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
    break-inside: avoid;
    padding: 30px 20px;
  }

  #section1 {
    display: flex;
    align-items: top;
    justify-content: space-between;
  }

  #section2 {
    display: flex;
  }

  #section3 {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 200px;
  }

  #chr-notes {
    padding-top: 0;
  }

  #print-pdf-status-score {
    display: flex;
    padding-top: 0;
    #print-pdf-status-score-item {
      width: 50%;
    }
  }

  #flex-progress {
    display: flex;
    flex-direction: row;
  }

  #print-width {
    width: 100%;
  }

  #chr-progress {
    height: 100%;
    width: 50%;
  }

  #chr-security-stability-graph {
    height: 100%;
    width: 50%;
  }

  #padding-top-bottom {
    width: 100%;
    break-inside: avoid;
    margin-bottom: 50px;
    padding-top: 20px;
  }

  #margin-top {
    margin-top: 0;
  }
  #right-header {
    width: 50%;
    #right-header-item {
      display: flex;
      justify-content: space-between;
      align-items: top;
    }
  }
}
</style>
